import * as React from 'react';

import './ModalPaymentStatusMobile.scss';
import i18n from 'src/translation/i18n';

interface IModalPaymentStatusProps {
  authorized: boolean;
  trackingNumber?: string;
  errorMessage?: string;
  closeStatusModal: () => void;
}

interface IModalPaymentStatusState {
  statusMessage: string;
  statusSubtitle: string;
  statusColor: any;
}

class ModalPaymentStatus extends React.Component<
  IModalPaymentStatusProps,
  IModalPaymentStatusState
> {
  public componentWillMount = () => {
    if (this.props.authorized) {
      this.setState({
        statusMessage: `${i18n.t('payments.paymentInitiated')}`,
        statusSubtitle: `${i18n.t('payments.paymentSucess')}`,
        statusColor: {
          backgroundColor: 'rgba(23, 138, 53, 0.19)'
        }
      });
    } else {
      this.setState({
        statusMessage: `${i18n.t('payments.unableToProcessPayment')}`,
        statusSubtitle: this.props.errorMessage,
        statusColor: {
          backgroundColor: 'rgba(244, 67, 54, 0.25)'
        }
      });
    }
  };

  public render() {
    return (
      <div
        className="rp-modal-payment-status container-fluid"
        style={this.state.statusColor}
      >
        <div className="row">
          <div className="col-12 d-flex justify-content-end">
            <i
              className="rpds-close rp-close-status-modal"
              onClick={this.props.closeStatusModal}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-2 d-flex justify-content-center">
            {this.props.authorized ? (
              <i className="rpds-check-circle" />
            ) : (
              <i className="rpds-error" />
            )}
          </div>
          <div className="col-10 d-flex flex-column justify-content-center">
            <h3 className="rp-modal-payment-status--message">
              {this.state.statusMessage}
            </h3>
            <h6 className="rp-modal-payment-status--subtitle">
              {this.state.statusSubtitle}
            </h6>
            {this.props.trackingNumber ? (
              <span className="rp-modal-payment-status-mobile-track">
                {this.props.trackingNumber}
              </span>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default ModalPaymentStatus;
